// extracted by mini-css-extract-plugin
export var actionText = "_mg-4";
export var container = "_mg-0";
export var leftSection = "_mg-1";
export var rightSection = "_mg-2";
export var settingsButton = "_mg-6";
export var settingsIcon = "_mg-7";
export var shortcut = "_mg-5";
export var shortcutGroup = "_mg-3";